// @todo: Migrate to @wandb/components. For more details see:
// https://www.notion.so/wandbai/Migrating-components-207e2f5c7ef380129201f72a5770a8db
import {Button} from '@wandb/weave/components/Button';
import React from 'react';

type LogSearchBrowserProps = {
  index: number;
  count: number;
  onSetIndex: (index: number) => void;
};

/**
 * This component allows jumping forwards and backwards through the
 * search results for a Log.
 */
export const LogSearchBrowser = ({
  index,
  count,
  onSetIndex,
}: LogSearchBrowserProps) => {
  const onUp = () => {
    onSetIndex(index - 1);
  };
  const onDown = () => {
    onSetIndex(index + 1);
  };
  return (
    <span className="inline-flex h-fit items-center">
      <Button
        aria-label="go to previous match"
        icon="chevron-up"
        variant="ghost"
        onClick={onUp}
        disabled={index === 0 || count === 0}
      />
      <Button
        aria-label="go to next match"
        icon="chevron-down"
        variant="ghost"
        onClick={onDown}
        disabled={index === count - 1 || count === 0}
      />
      <span className="ml-8 font-semibold">
        {count === 0 ? '0/0' : `${index + 1}/${count}`}
      </span>
    </span>
  );
};
